import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUtils from "hooks/useUtils";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { siteRoutes } from "utils/helpers/enums/routes";
import AmbassadorCommunity from "./component/AmbassadorCommunity";
import useAmbassador from "../useHooks";
import ExperienceDetail from "./component/ExperienceDetail";
import AmbassadorBreadcrumb, { AmbassadorBreadcrumbLink } from "components/breadcrumbs/AmbassadorBreadcrumb";
import { MdArrowBack } from "react-icons/md";

interface Tab {
  name: string;
  Component: JSX.Element;
}

const AmbassadorExperiencesView = () => {
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { getAmbassadorExperienceById } = useAmbassador();

  const tabs: Tab[] = [
    { name: "Overview", Component: <ExperienceDetail eventData={data} /> },
    {
      name: "Community",
      Component: <AmbassadorCommunity eventId={data?.id} />,
    },
  ];

  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

  // Breadcrumb links
  const breadcrumbLinks: AmbassadorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.ambassadorHome },
    { title: "Admin Experience Detail", path: siteRoutes.ambassadorAdminExperienceDetail },
  ];

  useEffect(() => {
    if (params?.id) {
      getAmbassadorExperienceById(params.id, setData);
    }
  }, [params?.id]);

  const goToBack = () => {
    navigate(-1);
  };

  return (
    <div className="container">
      {/* Breadcrumb Navigation */}
      <AmbassadorBreadcrumb links={breadcrumbLinks} />
      
      <div className="">

        <div className="flex gap-4 items-center flex-wrap mb-6">
          <h2 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            {data?.name || ""}
          </h2>
        </div>
      
        {/* Tab Navigation */}
        <div className="flex gap-6 mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`text-sm font-semibold pb-3 px-1 transition-colors duration-300 ${
                activeTab.name === tab.name
                  ? "text-ambassadorBlue border-b-2 border-ambassadorBlue"
                  : "text-mediumGrayText hover:text-ambassadorBlue"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="min-h-[400px]">
          {activeTab.name === "Overview" ? (
            <ExperienceDetail eventData={data} />
          ) : activeTab.name === "Community" ? (
            <AmbassadorCommunity eventId={data?.id} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AmbassadorExperiencesView;
